var React = require('react');

function EventsAndEcommerce (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 3L22 7V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V7.004L4 3H20ZM12 10L8 14H11V18H13V14H16L12 10ZM18.764 5H5.236L4.237 7H19.764L18.764 5Z","fill":"#FF7DA4"}));
}

EventsAndEcommerce.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = EventsAndEcommerce;

EventsAndEcommerce.default = EventsAndEcommerce;
